import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Label } from './ui/label';
import { Input } from './ui/input';

const BoardFilters = ({ boardType, filters, onFilterChange }) => {
  const renderProjectFilters = () => (
    <div className="grid grid-cols-3 gap-4">
      <div>
        <Label className="text-xs">Min Progress</Label>
        <Input
          type="number"
          min="0"
          max="100"
          placeholder="0%"
          value={filters.minProgress || ''}
          onChange={(e) => onFilterChange('minProgress', e.target.value)}
          className="h-8"
        />
      </div>
      <div>
        <Label className="text-xs">Max Progress</Label>
        <Input
          type="number"
          min="0"
          max="100"
          placeholder="100%"
          value={filters.maxProgress || ''}
          onChange={(e) => onFilterChange('maxProgress', e.target.value)}
          className="h-8"
        />
      </div>
      <div>
        <Label className="text-xs">Status</Label>
        <Select
          value={filters.status || 'all'}
          onValueChange={(value) => onFilterChange('status', value === 'all' ? '' : value)}
        >
          <SelectTrigger className="h-8">
            <SelectValue placeholder="All statuses" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            <SelectItem value="to_do">To Do</SelectItem>
            <SelectItem value="in_progress">In Progress</SelectItem>
            <SelectItem value="review">Review</SelectItem>
            <SelectItem value="done">Done</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );

  const renderMarketingFilters = () => (
    <div className="grid grid-cols-3 gap-4">
      <div>
        <Label className="text-xs">Channel</Label>
        <Select
          value={filters.channel || 'all'}
          onValueChange={(value) => onFilterChange('channel', value === 'all' ? '' : value)}
        >
          <SelectTrigger className="h-8">
            <SelectValue placeholder="All channels" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All channels</SelectItem>
            <SelectItem value="Social">Social Media</SelectItem>
            <SelectItem value="Email">Email</SelectItem>
            <SelectItem value="Ads">Ads</SelectItem>
            <SelectItem value="SEO">SEO</SelectItem>
            <SelectItem value="Event">Event</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs">Status</Label>
        <Select
          value={filters.status || 'all'}
          onValueChange={(value) => onFilterChange('status', value === 'all' ? '' : value)}
        >
          <SelectTrigger className="h-8">
            <SelectValue placeholder="All statuses" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            <SelectItem value="planning">Planning</SelectItem>
            <SelectItem value="in_production">In Production</SelectItem>
            <SelectItem value="published">Published</SelectItem>
            <SelectItem value="analyzing">Analyzing</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs">Launch Date</Label>
        <Input
          type="date"
          value={filters.launchDate || ''}
          onChange={(e) => onFilterChange('launchDate', e.target.value)}
          className="h-8"
        />
      </div>
    </div>
  );

  const renderSalesFilters = () => (
    <div className="grid grid-cols-4 gap-4">
      <div>
        <Label className="text-xs">Stage</Label>
        <Select
          value={filters.stage || 'all'}
          onValueChange={(value) => onFilterChange('stage', value === 'all' ? '' : value)}
        >
          <SelectTrigger className="h-8">
            <SelectValue placeholder="All stages" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All stages</SelectItem>
            <SelectItem value="lead">Lead</SelectItem>
            <SelectItem value="contacted">Contacted</SelectItem>
            <SelectItem value="proposal">Proposal</SelectItem>
            <SelectItem value="negotiation">Negotiation</SelectItem>
            <SelectItem value="won">Won</SelectItem>
            <SelectItem value="lost">Lost</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs">Min Deal Value (€)</Label>
        <Input
          type="number"
          min="0"
          placeholder="0"
          value={filters.minDealValue || ''}
          onChange={(e) => onFilterChange('minDealValue', e.target.value)}
          className="h-8"
        />
      </div>
      <div>
        <Label className="text-xs">Max Deal Value (€)</Label>
        <Input
          type="number"
          min="0"
          placeholder="∞"
          value={filters.maxDealValue || ''}
          onChange={(e) => onFilterChange('maxDealValue', e.target.value)}
          className="h-8"
        />
      </div>
      <div>
        <Label className="text-xs">Company</Label>
        <Input
          type="text"
          placeholder="Filter by company..."
          value={filters.company || ''}
          onChange={(e) => onFilterChange('company', e.target.value)}
          className="h-8"
        />
      </div>
    </div>
  );

  if (!boardType || boardType === 'project') return renderProjectFilters();
  if (boardType === 'marketing') return renderMarketingFilters();
  if (boardType === 'sales') return renderSalesFilters();

  return null;
};

export default BoardFilters;
